exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-792b7521]{margin-left:15px}.fl-r[data-v-792b7521]{float:right}.mt-20[data-v-792b7521]{margin-top:20px}.mr-20[data-v-792b7521]{margin-right:20px}#print[data-v-792b7521]{display:none}.tableColumns[data-v-792b7521]{height:auto;float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-792b7521","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/consumablesStock/inventory/detail.vue
// module id = pW+N
// module chunks = 0